export default "__VITE_ASSET__BknHyvD___"